module.exports = __webpack_public_path__ + "5d0a52c74d789b731c60990bb845b3b0.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/furnitures/floor_items/violin.png
// module id = 1589
// module chunks = 0